import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CompanySize, ModalService } from 'npx-family-happy-common';
import { Subject, takeUntil } from 'rxjs';
import {
  NgbCollapseModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { B2BCompanyServices } from '../b2b-company-services/b2b-company.services';
import { B2BCompanyExtended } from '../b2b-company-services/b2b-company.services';
import { AlertComponent } from 'src/app/shared/components/modals/alert/alert.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-b2b-company-dashboard',
  templateUrl: './b2b-company-dashboard.component.html',
  styleUrls: ['./b2b-company-dashboard.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbCollapseModule,
    RouterModule,
    NgbPaginationModule,
    AlertComponent,
  ],
})
export class B2BCompanyDashboardComponent implements OnInit, OnDestroy {
  filters = new UntypedFormGroup({
    id: new UntypedFormControl(null),
    name: new UntypedFormControl(null),
    vatNumber: new UntypedFormControl(null),
    size: new UntypedFormControl(null),
    passive: new UntypedFormControl(false),
  });

  companies: Array<B2BCompanyExtended> = [];
  private unsubscribe = new Subject<void>();
  showDeleteConfirm = false;
  selectedCompanyId = '';

  isCollapsed = true;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  companySizes = [
    { value: null, label: 'Tutte' },
    { value: 'EXTRA_SMALL', label: '1-10 dipendenti' },
    { value: 'SMALL', label: '11-50 dipendenti' },
    { value: 'MEDIUM', label: '51-200 dipendenti' },
    { value: 'LARGE', label: '200+ dipendenti' },
  ];

  constructor(
    private b2bCompanyServices: B2BCompanyServices,
    private router: Router,
    private modalService: ModalService
  ) {
    this.updateFilters();
  }

  ngOnInit(): void {
    this.loadCompanies();
  }

  openCompanyDetail(id: string) {
    this.router.navigate([`b2b-companies/${id}`]);
  }

  createCompany() {
    this.router.navigate(['b2b-companies/create']);
  }

  onPageChange() {
    if (this.page > 0) {
      this.loadCompanies();
    }
  }

  deleteCompany(id: string) {
    this.selectedCompanyId = id;
    this.showDeleteConfirm = true;
  }

  confirmDelete(answer: boolean) {
    if (answer && this.selectedCompanyId) {
      this.b2bCompanyServices
        .deleteCompany(this.selectedCompanyId)
        .subscribe(() => {
          this.modalService.showSuccessMessage('Azienda eliminata');
          this.loadCompanies();
        });
    }
    this.showDeleteConfirm = false;
  }

  applyFilters() {
    this.b2bCompanyServices.setFilters(this.filters.value);
    this.page = 1;
    this.loadCompanies();
  }

  updateFilters() {
    this.b2bCompanyServices.getFilters().subscribe((filters) => {
      this.filters.patchValue({
        ...filters,
      });
    });
  }

  resetFilters() {
    this.filters.setValue({
      id: null,
      name: null,
      vatNumber: null,
      size: null,
    });
    this.b2bCompanyServices.setFilters(this.filters.value);
    this.loadCompanies();
  }

  private loadCompanies() {
    this.b2bCompanyServices
      .getAllCompanies(this.page - 1, this.pageSize, this.filters.value)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((companyPage) => {
        this.companies = companyPage.content;
        this.page = companyPage.number + 1;
        this.pageSize = companyPage.size;
        this.collectionSize = companyPage.totalElements;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getCompanySizeLabel(size: CompanySize | null): string {
    const sizeOption = this.companySizes.find(
      (option) => option.value === size
    );
    return sizeOption ? sizeOption.label : 'N/A';
  }

  createInviteLink(id: string) {
    const inviteLink = `${environment.areaClientiURL}/sign-up/${id}`;
    navigator.clipboard.writeText(inviteLink);
    this.modalService.showSuccessMessage(
      'Link invito creato con successo e pronto per essere incollato: ' +
        inviteLink
    );
  }
}
